import * as React from 'react';
import * as style from './style.sass';

const loader = require('./assets/loader.gif');

interface PropsShape {
  overlay?: boolean;
  className?: string;
}

export class Loader extends React.Component<PropsShape> {
  componentDidMount() {
    if (this.props.overlay) {
      document.documentElement.style.overflow = 'hidden';
    }
  }

  componentWillUnmount() {
    if (this.props.overlay) {
      document.documentElement.style.overflow = '';
    }
  }

  render() {
    const { overlay, className } = this.props;

    const image = (<img
      className={`${style.loader} ${className ? className : ''}`}
      src={loader}
    />);

    return overlay ? (<div className={style.overlay}>{image}</div>) : image;
  }
}
